import Vue from "vue";
import VueGtag from "vue-gtag";
import router from "./router";

Vue.use(VueGtag, { config: { id: "G-DX9E75JFLW", params: {send_page_view: true} } }, );
//measurement ID G-DX9E75JFLW
//https://kagasu.hatenablog.com/entry/2022/07/27/112623
